import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-build-status',
  templateUrl: './display-build-status.component.html',
})
export class DisplayBuildStatusComponent implements OnInit {
  @Input() record: any;
  @Input() field: any;

  constructor() { }

  ngOnInit(): void {
  }

}
